// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import Radio from 'vant/lib/radio';
import 'vant/lib/radio/style';

import RadioGroup from 'vant/lib/radio-group';
import 'vant/lib/radio-group/style';
import { Dialog } from 'vant';

Vue.use(Dialog);
Vue.use(Radio);
Vue.use(RadioGroup);

Vue.config.productionTip = false
Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js